export default __webpack_public_path__ + "static/media/unlocked-disabled.fb4bd45b.svg";